import {ADD_TO_CART,  CLEAR_CART,  REMOVE_FROM_CART,
  SET_CART_ITEMS_FROM_STORAGE,
  UPDATE_QUANTITY,
} from '../actionConstants';
import {clearCartStorage, getCartItemsByUserId, saveCartToStorage} from '../localStorage/localCartStorage';

// Add item to cart
export const addToCart = product => async dispatch => {
  dispatch({
    type: ADD_TO_CART,
    payload:product,
  });
};

// Remove item from cart
export const removeFromCart = ({productId, size}) => {
  return {
    type: REMOVE_FROM_CART,
    payload: {productId, size},
  };
};

export const updateQuantity = ({productId, size, quantity}) => {
  return {
    type: UPDATE_QUANTITY,
    payload: {productId, size, quantity},
  };
};

export const clearCart = userId => async dispatch => {
  clearCartStorage(userId); 
  dispatch({
    type: CLEAR_CART,
    payload: {userId},
  });
};

export const loadCartFromStorage = payload => async dispatch => {
  const storedCart = await getCartItemsByUserId(payload);
  dispatch({
    type: SET_CART_ITEMS_FROM_STORAGE,
    payload: storedCart,
  });
};
